








































































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelContainer from '@/components/LabelContainer.vue';
import Accordion from '@/components/Accordion.vue';
import { IMergeFieldProperty } from '@/fields/merge-field/types/merge-field-property';
import { mergeFieldProperties } from '@/fields/merge-field/constants/merge-field-properties';
import { EMergeCategory } from '@/fields/merge-field/types/enums/merge-category';
import { EMergeType } from '@/fields/merge-field/types/enums/merge-type';
import { EnumDocumentType } from '@/enums/DocumentType';

@Component({
  components: {
    LabelContainer,
    Accordion,
  },
})
export default class MergeFieldDropDown extends Vue {
  @Prop() selected?: IMergeFieldProperty;
  @Prop() documentType: EnumDocumentType;
  open: number = -1;

  get title(): string {
    return this.selected ? this.selected.name : 'select-property';
  }

  get documentProperties(): IMergeFieldProperty[] {
    return mergeFieldProperties.filter(
      (property: IMergeFieldProperty) => property.category === EMergeCategory.Document
    );
  }

  get senderProperties(): IMergeFieldProperty[] {
    return mergeFieldProperties.filter(
      (property: IMergeFieldProperty) => property.category === EMergeCategory.Sender
    );
  }

  get recipientProperties(): IMergeFieldProperty[] {
    return mergeFieldProperties.filter(
      (property: IMergeFieldProperty) => property.category === EMergeCategory.Recipient
    );
  }

  get signingProperties(): IMergeFieldProperty[] {
    return mergeFieldProperties.filter(
      (property: IMergeFieldProperty) => property.category === EMergeCategory.Signing
    );
  }

  get customProperties(): IMergeFieldProperty[] {
    return mergeFieldProperties.filter(
      (property: IMergeFieldProperty) => property.category === EMergeCategory.Custom
    );
  }

  handleToggle(open: number) {
    this.open = open;
  }

  handleSelectProperty(property: IMergeFieldProperty) {
    this.open = -1;
    this.$emit('select', property);
  }

  propertyDisabled(property: IMergeFieldProperty): boolean {
    if (this.documentType === EnumDocumentType.Introduction) {
      if (property.category === EMergeCategory.Signing) {
        return true;
      }
    }
    if (
      this.documentType === EnumDocumentType.Hr ||
      this.documentType === EnumDocumentType.Introduction
    ) {
      if (property.type === EMergeType.DocumentValue) {
        return true;
      }
    }
    return false;
  }
}
